import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users, UserPlus, Phone, Euro } from 'lucide-react';
import { useGetPromoterStatsQuery } from '../../store/promoterApi';

const PromotersStats: React.FC = () => {
  const { t } = useTranslation();
  const { data: stats, isLoading } = useGetPromoterStatsQuery();

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(4)].map((_, index) => (
          <div key={index} className="bg-white p-6 rounded-xl shadow-sm animate-pulse">
            <div className="flex items-center justify-between">
              <div className="flex-1">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-8 bg-gray-200 rounded w-1/2 mb-2"></div>
              </div>
              <div className="w-12 h-12 bg-gray-200 rounded-lg"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  const displayStats = [
    {
      title: t('promoters.stats.total'),
      value: stats?.total ?? 0,
      icon: Users,
      color: 'bg-gradient-to-r from-purple-500 to-purple-600',
    },
    {
      title: t('promoters.stats.invited'),
      value: stats?.invited ?? 0,
      icon: UserPlus,
      color: 'bg-gradient-to-r from-yellow-500 to-orange-500',
    },
    {
      title: t('promoters.stats.readyForCall'),
      value: stats?.readyForCall ?? 0,
      icon: Phone,
      color: 'bg-gradient-to-r from-green-500 to-emerald-600',
    },
    {
      title: t('promoters.stats.totalRewards'),
      value: `${(stats?.totalRewards ?? 0).toLocaleString()}€`,
      icon: Euro,
      color: 'bg-gradient-to-r from-orange-500 to-red-500',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {displayStats.map((stat, index) => (
        <div key={index} className="bg-white p-6 rounded-xl shadow-sm">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">{stat.title}</p>
              <p className="text-2xl font-semibold text-gray-900">{stat.value}</p>
            </div>
            <div className={`p-3 rounded-lg ${stat.color}`}>
              <stat.icon className="w-6 h-6 text-white" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PromotersStats;
